import { GzIconButtonWebComponent } from './component/GzIconButtonWebComponent';
import { WEB_COMPONENT_GZ_ICON_BUTTON } from '../../webcomponents.constants';

export { GzIconButtonWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_ICON_BUTTON, GzIconButtonWebComponent);
